import { useEffect } from "react";
import { login, completeLogin } from "../auth";
import isAuthenticated from "../isAuthenticated";
import { State } from "../../reducers";
import { Navigate, useLocation } from "react-router-dom";
import { BootstrapSpinner } from "../../spinners/bootstrapSpinner";
import { useMunicipality } from "../../../Contexts/MunicipalityKey";
import { useAppDispatch, useAppSelector } from "../../../Hooks";

const Login = (myLocation: any) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const municipality = useMunicipality();

  const authState = useAppSelector(state => state.auth);

  const userAuthenticated = isAuthenticated(authState.user);

  useEffect(() => {
    if (location.pathname === "/login/response") {
      dispatch(completeLogin());
    } else if (!userAuthenticated) {
      localStorage.setItem(
        "state",
        JSON.stringify(myLocation.location?.pathname)
      );
      localStorage.setItem('municipality', municipality.name.trim());
      dispatch(login());
    }
  }, [
    dispatch,
    location,
    userAuthenticated,
    myLocation.location?.pathname,
  ]);

  let from = sessionStorage.getItem("location") || "/";

  if (userAuthenticated) {
    return <Navigate to={from} />;
  } else if (authState.error) {
    return <div className="ErrorMsg">{authState.error.message}</div>;
  } else if (authState.loading) {
    return <BootstrapSpinner title="Autentiserer" />;
  } else {
    return <p>Du er ikke logget inn</p>;
  }
}

export default Login;
